import { ProgramsBox, IBLSpinLoader } from '../../../components';
import './ProgramsViewContent.css';
import { NoItemView } from '../../../components/NoItemView';
import React from 'react';
import { isAdmin, useProfilePrograms } from '../../../hooks';
import { inIframe } from '../../../utils';
import { useTranslation } from 'react-i18next';

export const ProgramsViewContent = ({ username, userId }) => {
  const { profilePrograms, profileProgramsLoaded } = useProfilePrograms(
    username,
    userId
  );
  const { t } = useTranslation('library');

  return (
    <span>
      <div className="ov_panel active" data-name="programs">
        <div className="br_cont">
          {profileProgramsLoaded ? (
            <div className="br_row">
              <div className="div-block-430 sl pathway_grid">
                <ProgramsBox
                  profilePrograms={profilePrograms}
                  profileProgramsLoaded={profileProgramsLoaded}
                />
              </div>
            </div>
          ) : (
            <IBLSpinLoader size={40} containerHeight={'200px'} />
          )}
          {profileProgramsLoaded &&
            (!profilePrograms || profilePrograms.length === 0) &&
            inIframe() && (
              <NoItemView
                displayMessage={
                  !inIframe()
                    ? t("You haven't enrolled in any programs yet.")
                    : t(`${username} doesn't have any enrolled programs yet.`)
                }
                displayPadding={true}
              />
            )}
        </div>
      </div>
    </span>
  );
};
